import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import "@/App.css";

import Landing from "@/pages/marketing/Landing";
import Login from "@/pages/bitepal/Login";
import Onboarding from "@/pages/bitepal/Onboarding";
import Home from "@/pages/bitepal/Home";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const sessionId = new URLSearchParams(window.location.hash.substring(1)).get("session_id");
      if (!sessionId) { navigate("/"); return; }
      try {
        await api("/auth/session", { method: "POST", body: { session_id: sessionId } });
        navigate("/app");
      } catch { navigate("/"); }
    })();
  }, [navigate]);
  return <Splash label="Signing you in..." />;
};

export const Splash = ({ label }) => (
  <div className="min-h-screen bg-[#F5F0E8] flex items-center justify-center">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-[#651F33] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      {label && <p className="text-slate-500">{label}</p>}
    </div>
  </div>
);

const Gate = () => {
  const [state, setState] = useState({ loading: true, authed: false, onboarded: false, user: null });
  useEffect(() => {
    (async () => {
      try {
        const user = await api("/auth/me");
        let onboarded = false;
        try { onboarded = !!(await api("/profile")); } catch {}
        setState({ loading: false, authed: true, onboarded, user });
      } catch {
        setState({ loading: false, authed: false, onboarded: false, user: null });
      }
    })();
  }, []);
  if (state.loading) return <Splash />;
  if (!state.authed) return <Navigate to="/" replace />;
  if (!state.onboarded) return <Navigate to="/onboarding" replace />;
  return <Home user={state.user} />;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/app" element={<Gate />} />
    </Routes>
  );
};

function App() {
  useEffect(() => { document.documentElement.classList.remove("dark"); }, []);
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-right" theme="light" />
    </BrowserRouter>
  );
}

export default App;
